import { render, staticRenderFns } from "./MoreThanOneCard.vue?vue&type=template&id=6185083d"
import script from "./MoreThanOneCard.vue?vue&type=script&lang=js"
export * from "./MoreThanOneCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports